export default "<div class=\"row\" #canvas></div>"